/**
 * AuthGuard Component
 *
 * Route-level authentication guard for all dashboard routes.
 * Checks sessionStorage for a valid token; redirects to /authentication if absent.
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { TokenService } from '../services/TokenService';

// Module-level singleton — avoids "new per render" anti-pattern
const tokenService = new TokenService();

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const location = useLocation();
  const token = tokenService.getToken();


  if (token === null) {
    return <Navigate to="/authentication" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default AuthGuard;
